import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  search: any;
  setSearch: React.Dispatch<React.SetStateAction<any>>;
};

export default function PublishJobsTableToolbar({ search, setSearch }: Props) {
  return (
    <Stack
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{
        xs: 'column',
        md: 'row',
      }}
    >
      <TextField
        value={search?.subject}
        sx={{
          width: { xs: 1, md: 300 },
        }}
        size="small"
        placeholder="Search Publish Jobs"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: '#c6ddb4' }} />
            </InputAdornment>
          ),
        }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setSearch({ ...search, subject: event.target.value });
        }}
      />

      {(search?.status || search?.subject) && (
        <Button
          color="error"
          onClick={() => setSearch({ ...search, status: '', subject: '' })}
          startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
        >
          Clear
        </Button>
      )}
    </Stack>
  );
}
